import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs';

import { AbstractCacheService, ElasticSearchService, UserDoc, UserElsQuery } from '@contact/upgrade';

import { HistoryService } from '../history.service';

@Injectable({
  providedIn: 'root',
})
export class HistoryCsrCacheService extends AbstractCacheService<UserDoc[]> {
  constructor(private readonly historyService: HistoryService, private readonly elasticSearchService: ElasticSearchService) {
    super({
      defaultData: [],
      defaultParams: undefined,
    });
  }

  protected _load() {
    return this.historyService.getPerimeters().pipe(
      switchMap(({ domainUuidList, teamsUuid }) =>
        this.elasticSearchService
          .search(
            UserElsQuery.buildSearchByDomainsOrTeams({
              domainIds: domainUuidList,
              teamIds: teamsUuid,
              sort: { 'lastName.keyword': 'asc' },
            })
          )
          .pipe(map(value => value.data))
      )
    );
  }
}
